var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export var flattenMenu = function (menu) {
  var result = [];
  var traverse = function (menu) {
    var e_1, _a;
    if (result.some(function (m) {
      return m.id === menu.id;
    })) return; // Avoid duplicates
    result.push(menu);
    try {
      for (var _b = __values(menu.items), _c = _b.next(); !_c.done; _c = _b.next()) {
        var item = _c.value;
        if (item.menu) {
          traverse(item.menu);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };
  traverse(menu);
  return result;
};